import type { TFEmptyStateMessageProps } from '@tf/ui';
import { TFCard, TFEmptyStateMessage } from '@tf/ui';
import type React from 'react';

export const ErrorCard: React.FC<TFEmptyStateMessageProps> = (emtyStateMessageProps) => {
	// TODO: send error to sentry?
	return (
		<TFCard maw="50rem" ml="0" innerPadding="1.5rem">
			<TFEmptyStateMessage {...emtyStateMessageProps} />
		</TFCard>
	);
};
